"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEServiceCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _FAEText = require("../FAEText/FAEText");

var _FAEPrice = require("../FAEPrice/FAEPrice");

var _FAELoading = require("../FAELoading/FAELoading");

var _FAEImage = require("../FAEImage/FAEImage");

var _FAEVideo = require("../FAEVideo/FAEVideo");

require("./FAEServiceCard.scss");

const _excluded = ["src", "label", "price", "primary", "discountedPrice", "currencySymbol", "className", "type", "alt", "loading", "loaderProps", "onclick", "placeholder", "textOnImage", "textPosition"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEServiceCard = _ref => {
  let {
    src,
    label,
    price,
    primary,
    discountedPrice,
    currencySymbol,
    className = "",
    type,
    alt,
    loading,
    loaderProps,
    onclick,
    placeholder,
    textOnImage,
    textPosition
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const mode = primary ? "primary" : "";
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loading ? /*#__PURE__*/_react.default.createElement(_FAELoading.FAELoading, loaderProps) : /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
    className: "fae--service-card ".concat(className)
  }), type !== "video" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FAEImage.FAEImage, {
    className: "fae--service-card-image-or-video",
    src: src,
    alt: alt,
    placeholder: placeholder,
    textOnImage: textOnImage,
    textPosition: textPosition
  })) : /*#__PURE__*/_react.default.createElement(_FAEVideo.FAEVideo, {
    className: "fae--service-card-image-or-video",
    src: src,
    alt: alt,
    placeholder: placeholder
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--card-content ".concat(mode)
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    style: {
      marginBottom: mode === "" && "4px"
    },
    className: "fae--service-card-text-mobile",
    light: true
  }, label), /*#__PURE__*/_react.default.createElement(_FAEPrice.FAEPrice, {
    discountedPrice: discountedPrice,
    price: price,
    currencySymbol: currencySymbol
  }))));
};

exports.FAEServiceCard = FAEServiceCard;